<template>
  <div>
    <div class="premiumBtns">
      <template v-for="(btn, i) in selectData.elementItems">
        <span
          @click="btnClick(i)"
          :class="[
            'btns',
            'btn-l-' + selectData.elementItems.length,
            btn.color ? 'btn-c-' + btn.color : '',
            btn.disable && btn.disable == 'true' ? 'disable' : '',
          ]"
          >{{ btn.name }}</span
        >
      </template>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
export default {
  data() {
    return {
      value: "",
    };
  },
  props: ["selectData"],
  mounted() {
    this.selectData.elementValue = "";
  },
  methods: {
    // 点击事件
    btnClick(i) {
      if (this.selectData.elementItems[i].disable == "true") {
        return this.$notice.alert(this.selectData.elementItems[i].disableMsg);
      }
      this.value = this.selectData.elementItems[i].value;
      this.getResult();
    },
    getResult() {
      //选择后回调到父组件
      let value = this.value;
      this.selectData.elementValue = value;
      this.$emit("selected", {
        type: 1,
        item: this.selectData,
        value: value,
        noMemory: true,
      });
      setTimeout(() => {
        this.value = "";
        this.selectData.elementValue = "";
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.premiumBtns {
  width: 100%;
  padding: 30px 0 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  .btns {
    width: 30%;
    height: 70px;
    text-align: center;
    font-size: 30px;
    line-height: 70px;
    border-radius: 70px;
    margin-bottom: 10px;
    color: #fff;
  }
  .btn-c-blue {
    background-color: #0084ff;
    color: #fff;
  }
  .btn-c-orange {
    background-color: #ff6e06;
    color: #fff;
  }
  .btn-c-green {
    background-color: #67c23a;
    color: #fff;
  }
  .btn-c-grey {
    background-color: #909399;
    color: #fff;
  }
  .btn-c-red {
    background-color: #f56c6c;
    color: #fff;
  }
  .btn-l-1 {
    width: 100%;
  }
  .btn-l-2 {
    width: 46%;
  }
  .btn-l-3 {
    width: 30%;
  }
  .disable {
    background: #ddd !important;
    color: #333;
  }
}
</style>
